import { CheckIcon } from "@heroicons/react/24/solid";
import { useEffect, useRef, useState } from "react";
import { addAdmin, checkAdminId, checkPhone } from "../../services/ api_services";
import { Link, useNavigate } from "react-router-dom";
import { isEmpty, isString } from "lodash";
import useLoading from "../../hooks/useLoading";
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/react/24/outline";
import useToast from "../../hooks/useToast";
import { ToastTypes } from "../../context/ToastProvider";

function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
}

const LEFT_ARROW_ICON = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
        </svg>
    );
};

const initialRequest = {
    admin_id: "",
    pass: "",
    phone: "",
    name: "",
    email: "",
    type: "",
    address: "",
    address2: "",
    level_cd: "0001",
};

export default function SignUp() {
    const TITLE = "회원가입";
    const PREV = "이전";
    const NEXT = "다음";

    const navigate = useNavigate();
    const { showToast } = useToast();
    const { setLoading } = useLoading();

    const steps = [
        {
            id: "01",
            seq: "1",
            name: "시스템 정보",
            description: "아이디 및 비밀번호",
            status: "current",
        },
        {
            id: "02",
            seq: "2",
            name: "개인 정보",
            description: "이름 및 전화번호",
            status: "upcoming",
        },
        {
            id: "03",
            seq: "3",
            name: "사업 정보",
            description: "사업 주소",
            status: "upcoming",
        },
    ];

    const [menuType, setMenuType] = useState(steps);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [request, setRequest] = useState(initialRequest);
    const [confirmPass, setConfirmPass] = useState("");
    const [msgId, setMsgId] = useState("");
    const [msgPass, setMsgPass] = useState("");
    const [msgPhone, setMsgPhone] = useState("");
    const [activeId, setActiveId] = useState(false);
    const [isDuplicate, setIsDuplicate] = useState(false);

    const inputAdminIdRef = useRef();
    const inputAdminPhonRef = useRef();
    const inputPassRef = useRef();

    useEffect(() => {
        console.log("request ===>", request);
        const onlyNumbers = request.phone.replace(/\D/g, "");
        if (onlyNumbers.length === 11) {
            handleOnCheckPhone();
        } else {
            setIsDuplicate(null);
            setMsgPhone("");
        }
    }, [request.phone]);

    const handleOnCheckPhone  = async () => {
        if (request.phone && !isEmpty(request.phone) && isString(request.phone)) {
            if (request.phone.length !== 11) {
                return;
            }

            setLoading(true);
            const response = await checkPhone(request.phone.trim());
            if (response && response.status == 200) {
                setLoading(false);
                if (response.data.resultCode == 200) {
                    setIsDuplicate(false);
                    setMsgPhone("사용가능한 번호입니다");
                } else if (response.data.resultCode == 400) {
                    setIsDuplicate(true);
                    setMsgPhone("이미 사용중인 번호입니다");
                }
            } else {
                setLoading(false);
            }
            console.log("🚀 ~ handleOnCheckPhone ~ response:", response);
        }
    };

    function checkStateValues() {
        if (currentIndex === 1) {
            if (!activeId) {
                setMsgId("아이디 중복확인을 체크해 주세요.");
                inputAdminIdRef.current.focus();
                return false;
            }
            if (request.pass !== confirmPass) {
                setMsgPass("비밀번호가 일치하지 않습니다. 다시 입력해 주세요.");
                inputPassRef.current.focus();
                return false;
            }
            if (request.pass === confirmPass && !isEmpty(msgPass)) {
                setMsgPass("");
            }
        }
        else if (currentIndex === 2) {
            if (isDuplicate !== false) {
                if (isDuplicate === true) {
                    setMsgPhone("이미 등록된 핸드폰 번호입니다. 관리자에게 문의해주세요.");
                    inputAdminPhonRef.current.focus();
                    return false;
                }
                else {
                    setMsgPhone("전체 핸드폰 번호를 입력해주세요");
                    inputAdminPhonRef.current.focus();
                    return false;
                }
            }
        }
        return true;
    }

    function nextStep() {
        // console.log("menuType===>", menuType);

        const validatedStateValues = checkStateValues();

        if (validatedStateValues) {
            const updatedSteps = [...steps]; // Create a copy of the state

            switch (currentIndex) {
                case 1:
                    updatedSteps[0].status = "complete";
                    updatedSteps[1].status = "current";
                    setCurrentIndex(2);
                    break;
                case 2:
                    updatedSteps[0].status = "complete";
                    updatedSteps[1].status = "complete";
                    updatedSteps[2].status = "current";
                    setCurrentIndex(3);
                    break;
                case 3:
                    updatedSteps[0].status = "complete";
                    updatedSteps[1].status = "complete";
                    updatedSteps[2].status = "current";
                    break;
                default:
                    break;
            }
            setMenuType(updatedSteps);
        }
    }

    function prevStep() {
        const updatedSteps = [...steps]; // Create a copy of the state

        switch (currentIndex) {
            case 1:
                break;
            case 2:
                updatedSteps[0].status = "current";
                updatedSteps[1].status = "upcoming";
                updatedSteps[2].status = "upcoming";
                setCurrentIndex(1);
                break;
            case 3:
                updatedSteps[0].status = "complete";
                updatedSteps[1].status = "current";
                updatedSteps[2].status = "upcoming";
                setCurrentIndex(2);
                break;
            default:
                break;
        }
        setMenuType(updatedSteps);
    }

    /**
     * 회원가입
     */
    async function signUp() {
        console.log("START SIGN UP ==> ");
        // console.table(request);
        setLoading(true);
        const requestTemp = {
            admin_id: request.admin_id.trim(),
            pass: request.pass.trim(),
            phone: request.phone.trim(),
            name: request.name.trim(),
            email: request.email.trim(),
            type: "",
            address: request.address.trim(),
            address2: request.address2.trim(),
            level_cd: request.level_cd.trim(),
        };
        console.table(requestTemp);
        try {
            const response = await addAdmin(requestTemp);
            console.log("[add admin][response] => ", response);
            //Success
            if (response.status === 200) {
                setLoading(false);
                // console.info("회원가입 완료했습니다.");
                showToast(ToastTypes.SUCCESS, "성공", "회원가입이 완료됐습니다.");
                navigateToLogin();
            }
            //Error
            else {
                showToast(ToastTypes.ERROR, "오류", "회원가입할 때 오류가 발생했습니다. 관리자에게 문의해주세요.");
                setLoading(false);
            }
        } catch (e) {
            setLoading(false);
            console.error("[add admin][error] : ", e);
        }
    }

    const navigateToLogin = () => {
        const timer = setTimeout(navigate("/"), 1500);
        clearTimeout(timer);
    };

    const buttonPrev = (onClick) => {
        return (
            <button
                type="button"
                className="inline-flex w-32 items-center justify-center gap-x-1.5  rounded-md bg-white px-6 py-3 text-base font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                onClick={() => (onClick ? onClick() : null)}
            >
                <LEFT_ARROW_ICON className="-mr-0.5 h-5 w-5" aria-hidden="true" />
                {PREV}
            </button>
        );
    };

    const buttonNext = (onClick) => {
        return (
            <button
                type="button"
                className="inline-flex items-center justify-center w-32 rounded-md bg-blue-700 px-6 py-3 text-base font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
                onClick={() => (onClick != null ? onClick() : null)}
            >
                {NEXT}
            </button>
        );
    };

    const buttonRegister = () => {
        return (
            <button
                type="button"
                className="inline-flex items-center justify-center w-32 rounded-md bg-blue-700 px-6 py-3 text-base font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
                onClick={() => signUp()}
            >
                가입하기
            </button>
        );
    };

    const loginLink = () => {
        return (
            <div className="flex mt-5 mx-auto max-w-xl justify-end align-middle text-base">
                <p className="font-normal text-gray-700">
                    이미 등록하셨나요?
                    <Link to={"/"} className="font-bold ml-1 text-blue-600 hover:underline">
                        로그인
                    </Link>
                </p>
            </div>
        );
    };

    const updateRequestData = (field, value) => {
        if (isString(value)) {
            if (field === "phone") {
                value = value.replace(/[^0-9]/g, "");
                setIsDuplicate(null);
                setMsgPhone("");
            }
            if (field === "admin_id") {
                if (isEmpty(value)) {
                    setMsgId("");
                }
                if (isString(value) && value !== request.admin_id) {
                    setActiveId(false);
                    setMsgId("");
                }
            }
            setRequest((preVal) => {
                return {
                    ...preVal,
                    [field]: value,
                };
            });
        }
    };

    const handleOnClickCheckId = async () => {
        if (request.admin_id && !isEmpty(request.admin_id) && isString(request.admin_id)) {
            if (request.admin_id.length < 4) {
                setActiveId(false);
                setMsgId("아이디를 4글자 이상 입력해 주세요.");
                return;
            }

            setLoading(true);
            const response = await checkAdminId(request.admin_id.trim());
            if (response && response.status == 200) {
                setLoading(false);
                if (response.data.resultCode == 200) {
                    setActiveId(true);
                    setMsgId("사용가능한 아이디입니다");
                } else if (response.data.resultCode == 400) {
                    setActiveId(false);
                    setMsgId("이미 사용중인 아이디입니다");
                }
            } else {
                setLoading(false);
            }
            console.log("🚀 ~ handleOnClickCheckId ~ response:", response);
        }
    };

    return (
        <>
            <div className="lg:border-b lg:border-t lg:border-gray-200">
                <nav className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" aria-label="Progress">
                    <ol className="overflow-hidden rounded-md lg:flex lg:rounded-none lg:border-l lg:border-r lg:border-gray-200">
                        {menuType.map((step, stepIdx) => (
                            <li key={step.id} className="relative overflow-hidden lg:flex-1">
                                <div
                                    className={classNames(
                                        stepIdx === 0 ? "rounded-t-md border-b-0" : "",
                                        stepIdx === steps.length - 1 ? "rounded-b-md border-t-0" : "",
                                        "overflow-hidden border border-gray-200 lg:border-0"
                                    )}
                                >
                                    {step.status === "complete" ? (
                                        <div className="group">
                                            <span
                                                className="absolute left-0 top-0 h-full w-1 bg-transparent lg:bottom-0 lg:top-auto lg:h-1 lg:w-full"
                                                aria-hidden="true"
                                            />
                                            <span
                                                className={classNames(
                                                    stepIdx !== 0 ? "lg:pl-9" : "",
                                                    "flex items-start px-6 py-5 text-sm font-medium"
                                                )}
                                            >
                                                <span className="flex-shrink-0">
                                                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-700">
                                                        <CheckIcon className="h-6 w-6 text-white" aria-hidden="true" />
                                                    </span>
                                                </span>
                                                <span className="ml-4 mt-0.5 flex min-w-0 flex-col">
                                                    <span className="text-sm font-medium">{step.name}</span>
                                                    <span className="text-sm font-medium text-gray-500">{step.description}</span>
                                                </span>
                                            </span>
                                        </div>
                                    ) : step.status === "current" ? (
                                        <div aria-current="step">
                                            <span
                                                className="absolute left-0 top-0 h-full w-1 bg-blue-700 lg:bottom-0 lg:top-auto lg:h-1 lg:w-full"
                                                aria-hidden="true"
                                            />
                                            <span
                                                className={classNames(
                                                    stepIdx !== 0 ? "lg:pl-9" : "",
                                                    "flex items-start px-6 py-5 text-sm font-medium"
                                                )}
                                            >
                                                <span className="flex-shrink-0">
                                                    <span className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-blue-700">
                                                        <span className="text-blue-700">{step.id}</span>
                                                    </span>
                                                </span>
                                                <span className="ml-4 mt-0.5 flex min-w-0 flex-col">
                                                    <span className="text-sm font-medium text-blue-700">{step.name}</span>
                                                    <span className="text-sm font-medium text-gray-500">{step.description}</span>
                                                </span>
                                            </span>
                                        </div>
                                    ) : (
                                        <div className="group">
                                            <span
                                                className="absolute left-0 top-0 h-full w-1 bg-transparent lg:bottom-0 lg:top-auto lg:h-1 lg:w-full"
                                                aria-hidden="true"
                                            />
                                            <span
                                                className={classNames(
                                                    stepIdx !== 0 ? "lg:pl-9" : "",
                                                    "flex items-start px-6 py-5 text-sm font-medium"
                                                )}
                                            >
                                                <span className="flex-shrink-0">
                                                    <span className="flex h-10 w-10 items-center justify-center rounded-full border-2 border-gray-300">
                                                        <span className="text-gray-500">{step.id}</span>
                                                    </span>
                                                </span>
                                                <span className="ml-4 mt-0.5 flex min-w-0 flex-col">
                                                    <span className="text-sm font-medium text-gray-500">{step.name}</span>
                                                    <span className="text-sm font-medium text-gray-500">{step.description}</span>
                                                </span>
                                            </span>
                                        </div>
                                    )}

                                    {stepIdx !== 0 ? (
                                        <>
                                            {/* Separator */}
                                            <div className="absolute inset-0 left-0 top-0 hidden w-3 lg:block" aria-hidden="true">
                                                <svg
                                                    className="h-full w-full text-gray-300"
                                                    viewBox="0 0 12 82"
                                                    fill="none"
                                                    preserveAspectRatio="none"
                                                >
                                                    <path
                                                        d="M0.5 0V31L10.5 41L0.5 51V82"
                                                        stroke="currentcolor"
                                                        vectorEffect="non-scaling-stroke"
                                                    />
                                                </svg>
                                            </div>
                                        </>
                                    ) : null}
                                </div>
                            </li>
                        ))}
                    </ol>
                </nav>
            </div>
            {currentIndex === 1 ? (
                <div className="isolate bg-white px-6 py-24 sm:py-24 lg:px-8">
                    <div className="mx-auto max-w-2xl text-center">
                        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{TITLE}</h2>
                    </div>
                    <form method="POST" className="h-80 mx-auto mt-16 max-w-xl sm:mt-20" autoComplete="off">
                        <div className="min-w-full">
                            {/* <div className="flex justify-between mb-5"> */}
                            <div>
                                {/* <div className="w-4/5"> */}
                                <label htmlFor="userId" className="block text-sm font-semibold leading-6 text-gray-900">
                                    아이디
                                </label>
                                <div className="flex mt-2  max-w-full items-start justify-start align-top">
                                    <div className="flex items-center w-2/3 ">
                                        <div className="relative w-full items-center rounded-md shadow-sm">
                                            {!isEmpty(msgId) && !activeId && (
                                                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                                    <ExclamationCircleIcon
                                                        className={classNames("h-5 w-5 aria-hidden ", !activeId ? "text-red-500" : "")}
                                                    />
                                                </div>
                                            )}
                                            {activeId && (
                                                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                                    <CheckCircleIcon className="h-5 w-5 text-green-500" aria-hidden="true" />
                                                </div>
                                            )}
                                            <input
                                                type="text"
                                                id="signup_id"
                                                maxLength={20}
                                                autoComplete="off"
                                                aria-autocomplete="off"
                                                name="signup_id"
                                                prefix={<CheckCircleIcon height={16} width={16} />}
                                                ref={inputAdminIdRef}
                                                className={classNames(
                                                    "rounded-md w-full px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6",
                                                    !isEmpty(msgId) && !activeId
                                                        ? "border-1 border-red-500"
                                                        : activeId
                                                        ? "border-1 border-green-500"
                                                        : "border-0"
                                                )}
                                                value={request.admin_id ?? ""}
                                                onChange={(e) => updateRequestData("admin_id", e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        className="w-1/3 rounded-md bg-indigo-600 px-2.5 py-2 text-base font-semibold text-white shadow-sm hover:bg-indigo-500 ml-7"
                                        onClick={() => handleOnClickCheckId()}
                                    >
                                        중복확인
                                    </button>
                                </div>
                            </div>
                            {msgId && !isEmpty(msgId) && (
                                <div className="mb-5 mt-2">
                                    <span className={classNames("text-sm", activeId ? "text-green-500" : "text-red-500")}>* {msgId}</span>
                                </div>
                            )}
                            {isEmpty(msgId) && <div className="mb-5 mt-2" />}

                            <div className="mb-5">
                                <label htmlFor="password1" className="block text-sm font-semibold leading-6 text-gray-900">
                                    비밀번호
                                </label>
                                <div className="mt-2.5">
                                    <input
                                        type="password"
                                        name="password1"
                                        id="password1"
                                        autoComplete="off"
                                        placeholder="비밀번호"
                                        maxLength={20}
                                        ref={inputPassRef}
                                        className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6"
                                        value={request.pass ?? ""}
                                        onChange={(e) => updateRequestData("pass", e.target.value)}
                                    />
                                </div>
                            </div>
                            <div>
                                <label htmlFor="password2" className="block text-sm font-semibold leading-6 text-gray-900">
                                    비밀번호 확인
                                </label>
                                <div className="mt-2.5">
                                    <input
                                        type="password"
                                        name="password2"
                                        id="password2"
                                        autoComplete="off"
                                        placeholder="비밀번호 확인"
                                        maxLength={20}
                                        className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6"
                                        value={confirmPass ?? ""}
                                        onChange={(e) => setConfirmPass(e.target.value.trim())}
                                    />
                                </div>
                            </div>
                            {msgPass && !isEmpty(msgPass) && (
                                <div className="mb-5 mt-2">
                                    <span className="text-red-700 text-sm">* {msgPass}</span>
                                </div>
                            )}
                        </div>
                    </form>
                    {loginLink()}
                    <div className="mt-10 mx-auto max-w-xl">
                        {/* {buttonNext(nextStep)} */}
                        <button
                            className="block w-full rounded-md bg-blue-700 px-3 py-3 text-center text-base font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
                            onClick={() => nextStep()}
                        >
                            다음
                        </button>
                    </div>
                </div>
            ) : currentIndex === 2 ? (
                <div className="isolate bg-white px-6 py-24 sm:py-24 lg:px-8">
                    <div className="mx-auto max-w-2xl text-center">
                        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{TITLE}</h2>
                    </div>
                    <form method="POST" className="mx-auto mt-16 max-w-xl sm:mt-20 h-80">
                        <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
                            <div className="sm:col-span-2">
                                <label htmlFor="userName" className="block text-sm font-semibold leading-6 text-gray-900">
                                    이름
                                </label>
                                <div className="mt-2.5">
                                    <input
                                        type="text"
                                        name="userName"
                                        id="userName"
                                        //autoComplete="organization"
                                        className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6"
                                        value={request.name ?? ""}
                                        maxLength={30}
                                        onChange={(e) => updateRequestData("name", e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="tel" className="block text-sm font-semibold leading-6 text-gray-900">
                                    휴대폰 번호
                                </label>
                                <div className="mt-2.5">
                                    <input
                                        // className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6"
                                        className={classNames(
                                                    "rounded-md w-full px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6",
                                                    isDuplicate === true
                                                        ? "border-1 border-red-500"
                                                        : isDuplicate === false
                                                        ? "border-1 border-green-500"
                                                        : "border-0"
                                                )}
                                        type="tel"
                                        id="phone"
                                        name="phone"
                                        value={request.phone ?? ""}
                                        maxLength={20}
                                        ref={inputAdminPhonRef}
                                        onChange={(e) => updateRequestData("phone", e.target.value)}
                                    />
                                    {!isEmpty(msgPhone) && msgPhone ? (
                                        <div className="mb-5 mt-2">
                                            <span className={classNames("text-sm", isDuplicate ?  "text-red-500" : "text-green-500")}>* {msgPhone}</span>
                                        </div>
                                    ): null}
                                </div>
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="email" className="block text-sm font-semibold leading-6 text-gray-900">
                                    이메일
                                </label>
                                <div className="mt-2.5">
                                    <input
                                        type="email"
                                        name="email"
                                        autoComplete="email"
                                        className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6"
                                        value={request.email ?? ""}
                                        maxLength={40}
                                        onChange={(e) =>
                                            setRequest((preState) => {
                                                return {
                                                    ...preState,
                                                    email: e.target.value,
                                                };
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                    {loginLink()}
                    <div className="flex justify-center gap-x-6 mt-10">
                        {buttonPrev(prevStep)}
                        {buttonNext(nextStep)}
                    </div>
                </div>
            ) : currentIndex === 3 ? (
                <div className="isolate bg-white px-6 py-24 sm:py-24 lg:px-8">
                    <div className="mx-auto max-w-2xl text-center">
                        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{TITLE}</h2>
                    </div>
                    <form method="POST" className="mx-auto mt-16 max-w-xl sm:mt-20 h-80">
                        <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
                            <div className="sm:col-span-1">
                                <label htmlFor="addr" className="block text-sm font-semibold leading-6 text-gray-900">
                                    사업자 주소
                                </label>
                                <div className="mt-2.5">
                                    <input
                                        type="text"
                                        name="addr"
                                        id="addr"
                                        maxLength={100}
                                        className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6"
                                        value={request.address ?? ""}
                                        onChange={(e) => updateRequestData("address", e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="sm:col-span-2">
                                <div className="mt-2.5">
                                    <input
                                        type="text"
                                        name="addrInfo"
                                        id="addrInfo"
                                        maxLength={100}
                                        className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6"
                                        value={request.address2 ?? ""}
                                        onChange={(e) => updateRequestData("address2", e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                    {loginLink()}
                    <div className="flex justify-center gap-x-6 mt-10">
                        {buttonPrev(prevStep)}
                        {buttonRegister()}
                    </div>
                    {/* <div className="flex justify-center mt-10 gap-x-6">
                        {buttonPrev(prevStep)}
                        {buttonRegister()}
                    </div> */}
                </div>
            ) : null}
        </>
    );
}
